export default __webpack_public_path__ + "static/media/Ballastic.3bdcf50f.png";